import { render, staticRenderFns } from "./myDraft.vue?vue&type=template&id=bf3e76f4&scoped=true&"
import script from "./myDraft.vue?vue&type=script&lang=js&"
export * from "./myDraft.vue?vue&type=script&lang=js&"
import style0 from "./myDraft.vue?vue&type=style&index=0&id=bf3e76f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3e76f4",
  null
  
)

export default component.exports